import React from 'react';

const ShowOnMapIcon = function() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#488EC8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9626 20.292C16.4536 20.292 15.2257 19.065 15.2257 17.556C15.2257 16.047 16.4536 14.819 17.9626 14.819C19.4716 14.819 20.6986 16.047 20.6986 17.556C20.6986 19.065 19.4716 20.292 17.9626 20.292ZM23.5766 11.449C22.0456 9.87 20.0516 9 17.9626 9C15.8716 9 13.8777 9.87 12.3457 11.45C10.7907 13.054 9.93667 15.209 10.0037 17.363C10.1927 23.467 17.3826 28.22 17.6896 28.419L17.9586 28.594L18.2306 28.422C18.5366 28.228 25.7316 23.59 25.9216 17.362C25.9876 15.209 25.1326 13.053 23.5766 11.449Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export default ShowOnMapIcon;